// React
import React, { useEffect, useState, ChangeEvent } from "react"
import {
  useParams,
  useSearchParams,
  Link as ReactRouterLink,
  useNavigate,
} from "react-router-dom"

// Hooks and Redux
import { useAppSelector } from "../../../redux/hooks"

// MUI Components
import Box from "@mui/material/Box"
import Button from "@mui/material/Button"
import Checkbox from "@mui/material/Checkbox"
import FormControl from "@mui/material/FormControl"
import FormControlLabel from "@mui/material/FormControlLabel"
import Grid from "@mui/material/Grid"
import InputLabel from "@mui/material/InputLabel"
import MenuItem from "@mui/material/MenuItem"
import Select, { SelectChangeEvent } from "@mui/material/Select"
import TextField from "@mui/material/TextField"
import Typography from "@mui/material/Typography"
import Autocomplete from "@mui/material/Autocomplete"
import CircularProgress from "@mui/material/CircularProgress"
import Breadcrumbs from "@mui/material/Breadcrumbs"
import Link from "@mui/material/Link"

// MUI Icons
import HomeIcon from "@mui/icons-material/Home"
import PersonIcon from "@mui/icons-material/Person"
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft"
import EditIcon from "@mui/icons-material/Edit"
import {
  MultipleFileUpload,
  MultipleFileUploadStatusItem,
} from "@patternfly/react-core"
import UploadFileIcon from "@mui/icons-material/UploadFile"
import CloudUploadIcon from "@mui/icons-material/CloudUpload"

// Utils
import { useForm } from "react-hook-form"
import { useTranslation } from "react-i18next"
import { yupResolver } from "@hookform/resolvers/yup"
import * as yup from "yup"
import Swal from "sweetalert2"
import { ToastContainer, toast } from "react-toastify"
import jwtDecode from "jwt-decode"
import dayjs from "dayjs"

// Styles
import { green } from "@mui/material/colors"

// Types
import RoleType from "../../../@types/RoleType"
import { Role, TokenPayload, User } from "../../../@types"

// Services
import { getAllRoles } from "../../../services/RoleService"
import { editUserById, getUserById } from "../../../services/UserService"
import { getEmployerById } from "../../../services/EmpService"
import { sendFilesDocuments } from "../../../services/UserService"
import { updateEmployerData } from "../../../services/EmpService"
import { getDocumentsfile } from "../../../services/UserService"

interface readFile {
  fileName: string
  data?: string
  loadResult?: "danger" | "success"
  loadError?: DOMException
}
interface FormData {
  nameFile: string
  active: boolean
  fileContract: any
  // contract?: FileList; // ถ้าใช้ input type="file" ผ่าน react-hook-form
}

const EditEmp = () => {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const { t, i18n } = useTranslation()
  const { id } = useParams()

  const token = localStorage.getItem("access_token") || ""
  const decoded: TokenPayload = jwtDecode(token)
  const UserId = decoded?.UserId ? decoded.UserId : ""

  const { setValue } = useForm<FormData>({})

  const userRoleType = useAppSelector((state) => state.user.roletype)
  const havePermission = userRoleType === "Super Admin"

  const [editUserType, setEditUserType] = useState("")
  const [userData, setUserData] = useState({
    prefix: "",
    first_name_th: "",
    last_name_th: "",
    first_name_en: "",
    last_name_en: "",
    email: "",
    is_active: true,
    // id_card_number: "",
    date_of_birth: null,
    telephone: "",
    dmsFileId: "",
    // Role: {
    //   role_name: "",
    //   role_id: "",
    //   role_type: "",
    // },
  })
  const [roleData, setRoleData] = useState<Role[]>([])
  const [isNormalUser, setIsNormalUser] = useState<boolean>(true)
  const [userLoading, setUserLoading] = useState<boolean>(true)
  const [roleLoading, setRoleLoading] = useState<boolean>(true)
  const [filterLoading, setFilterLoading] = useState<boolean>(true)
  const [editLoading, setEditLoading] = useState<boolean>(false)
  const allSuccessLoading = !userLoading

  const [checkDmsFileId, setCheckDmsFileId] = useState<string>("")

  //   const [statusIcon, setStatusIcon] = useState("inProgress")
  const [documentData, setDocumentData] = useState<any[]>([])
  //   const [loading, setLoading] = useState(false)
  const [active, setActive] = useState<boolean>(false)
  const [fileName, setFileName] = useState<string>("")
  const [docName, setDocName] = useState<string>("")
  const [newFileName, setNewFileName] = useState<string>("")
  const [loadingUpload, setLoadingUpload] = useState<boolean>(false)
  const [userFiles, setUserFiles] = useState<File[]>([])
  const [currentFiles, setCurrentFiles] = useState<File[]>([])
  const [readFileData, setReadFileData] = useState<readFile[]>([])
  const [showStatus, setShowStatus] = useState(false)
  const [createLoading, setCreateLoading] = useState<boolean>(false)

  const [typePath, setTypePath] = React.useState<string>("")
  const [dmsImageData, setDmsImageData] = useState<string>("")

  const debugBase64 = (base64URL: string) => {
    let win = window.open()
    win?.document.write(
      '<iframe src="' +
        base64URL +
        '" frameborder="0" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;" allowfullscreen></iframe>'
    )
    return win
  }

  if (!havePermission) {
    navigate("/forbidden", { replace: true })
  }

  useEffect(() => {
    try {
      if (searchParams.has("type")) {
        const type = searchParams.get("type")
        if (type === "hr") {
          setEditUserType("HR Recruiter")
        } else if (type === "superadmin") {
          setEditUserType("Super Admin")
        } else if (type === "member") {
          setEditUserType("Member")
        } else if (type === "employer") {
          setTypePath("employer")
          setEditUserType("employer")
        } else {
          navigate("/admin/masterdata/users?type=member", { replace: true })
        }
      }
    } catch (error) {
      console.log(error)
      navigate("/servererror", { replace: true })
    }
  }, [searchParams, navigate])

  const handlePrefixChange = (event: SelectChangeEvent) => {
    try {
      setUserData((prevData) => ({
        ...prevData,
        prefix: event.target.value as string,
      }))
    } catch (error) {
      console.log(error)
      navigate("/servererror", { replace: true })
    }
  }

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    try {
      setUserData((prevData) => ({
        ...prevData,
        is_active: event.target.checked,
      }))
      setActive(event.target.checked)
    } catch (error) {
      console.log(error)
      navigate("/servererror", { replace: true })
    }
  }

  const sortOptionsByGroup = (options: Role[]): Role[] => {
    try {
      const groupedOptions: { [key: string]: Role[] } = {}

      options.forEach((option) => {
        if (!groupedOptions[option.role_type]) {
          groupedOptions[option.role_type] = []
        }
        groupedOptions[option.role_type].push(option)
      })

      const sortedOptions: Role[] = []
      Object.keys(groupedOptions)
        .sort()
        .forEach((group) => {
          sortedOptions.push(
            ...groupedOptions[group].sort((a, b) =>
              a.role_name.localeCompare(b.role_name)
            )
          )
        })

      return sortedOptions
    } catch (error) {
      console.log(error)
      navigate("/servererror", { replace: true })
      return []
    }
  }

  useEffect(() => {
    const fetchRoles = async () => {
      try {
        const response = await getAllRoles()

        if (response.data?.success) {
          const rolesData = response.data?.roles
          const activeRole = rolesData.filter(
            (role: Role) =>
              role.is_active === true && role.role_type !== "Member"
          )
          setRoleData(activeRole)
        }
      } catch (error) {
        console.log(error)
        navigate("/servererror", { replace: true })
      } finally {
        setRoleLoading(false)
      }
    }

    fetchRoles()
  }, [])

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const user_id = id as string
        let response = await getEmployerById(user_id)

        if (response?.status === 200 && response?.data?.user) {
          const userDataResponse = response.data?.user
          setNewFileName(userDataResponse.nameFile)

          if (!response.data?.success) {
            Swal.fire({
              title:
                i18n.language === "th"
                  ? response.data?.message_th
                  : response.data?.message_en,
              icon: "error",
              showCancelButton: false,
              confirmButtonColor: "#43A047",
              confirmButtonText: "OK!",
              allowOutsideClick: false,
              allowEscapeKey: false,
            }).then((result) => {
              if (result.isConfirmed) {
                window.location.assign("/admin/masterdata/users?type=member")
              }
            })
            return
          }

          if (userDataResponse.email) {
            const email_part: string[] = userDataResponse.email.split("@")
            if (email_part[1] === "betagro.com") {
              setIsNormalUser(false)
            } else {
              setIsNormalUser(true)
            }
          }

          setUserData((prevUserData) => ({
            ...prevUserData,
            prefix: userDataResponse.prefix || "",
            first_name_th: userDataResponse.first_name_th || "",
            last_name_th: userDataResponse.last_name_th || "",
            first_name_en: userDataResponse.first_name_en || "",
            last_name_en: userDataResponse.last_name_en || "",
            email: userDataResponse.email || "",
            is_active: userDataResponse.is_active,
            // id_card_number: userDataResponse.id_card_number || "",
            date_of_birth: userDataResponse.date_of_birth || "",
            telephone: userDataResponse.telephone || "",
            dmsFileId: userDataResponse.dmsFileId || "",
            nameFile: userDataResponse.nameFile || "Signed Image",
          }))
          setDocumentData([userDataResponse])
          setCheckDmsFileId(userDataResponse.dmsFileId)

          if (userDataResponse?.dmsFileId) {
            const base64Data = await getDocumentsfile(
              userDataResponse?.dmsFileId,
              "documentsEmp"
            )
            if (base64Data.status === 200) {
              setDmsImageData(base64Data?.data)
            }
          }
        }
      } catch (error) {
        console.log(error)
        navigate("/servererror", { replace: true })
      } finally {
        setUserLoading(false)
      }
    }

    fetchUser()
  }, [id, editUserType])

  const formValidationSchema = yup.object().shape({
    prefix: yup.string(),
    first_name_th: isNormalUser
      ? yup.string().required(`${t("กรุณาใส่ ชื่อภาษาไทย")}`)
      : yup.string(),
    last_name_th: isNormalUser
      ? yup.string().required(`${t("กรุณาใส่ นามสกุลภาษาไทย")}`)
      : yup.string(),
    first_name_en: yup.string().required(`${t("กรุณาใส่ ชื่อภาษาอังกฤษ")}`),
    last_name_en: yup.string().required(`${t("กรุณาใส่ นามสกุลภาษาอังกฤษ")}`),
    email: yup.string().email(`${t("Please enter Valid email")}`),
    telephone: isNormalUser
      ? yup
          .string()
          .required(`${t("Phone number is required")}`)
          .min(10, `${t("telephone must be at least 10 characters")}`)
          .max(10, `${t("telephone must be at most 10 characters")}`)
          .matches(/^[0-9]+$/, `${t("telephone must be number only")}`)
      : yup.string(),
  })

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(formValidationSchema),
  })

  const removeFiles = (namesOfFilesToRemove: string[]) => {
    const newCurrentFiles = userFiles.filter(
      (currentFile) =>
        !namesOfFilesToRemove.some((fileName) => fileName === currentFile.name)
    )
    setUserFiles(newCurrentFiles) //
    setCurrentFiles(newCurrentFiles)

    const newReadFiles = readFileData.filter(
      (readFile) =>
        !namesOfFilesToRemove.some((fileName) => fileName === readFile.fileName)
    )

    setReadFileData(newReadFiles)
  }

  const handleReadSuccess = (data: string, file: File) => {
    setReadFileData((prevReadFiles) => [
      ...prevReadFiles,
      {
        data,
        fileName: file.name,
        loadResult: "success",
      },
    ])
  }

  const handleReadFail = (error: DOMException, file: File) => {
    setReadFileData((prevReadFiles) => [
      ...prevReadFiles,
      {
        loadError: error,
        fileName: file.name,
        loadResult: "danger",
      },
    ])
  }

  const filterBySize = (file: any) => {
    const MAX_FILE_SIZE = 100 * 1024 // 2MB in bytes
    return file[0].size <= MAX_FILE_SIZE
  }

  const handleFileSelection = (
    e: ChangeEvent<HTMLInputElement>,
    type: string
  ) => {
    let files = e.target.files
    let idstokeep = [0, 2]
    if (files) {
      const checkSize = filterBySize(files)

      if (checkSize === true) {
        let droppedFile = Array.prototype.slice
          .call(files)
          .splice(idstokeep[0], idstokeep[1])

        const currentFileNames = userFiles.map((file) => file.name)

        const reUploads = droppedFile.filter((file) => {
          file.typeUpload = type
          setNewFileName(file.name)

          setDocName(file.name)

          return currentFileNames.includes(file.name)
        })

        Promise.resolve()
          .then(() => removeFiles(reUploads.map((file) => file.name)))
          .then(() =>
            setDocumentData((prevFiles) => {
              return [...prevFiles, ...droppedFile]
            })
          )
      } else {
        Swal.fire({
          icon: "error",
          title: `${t("Error")}`,
          text: `${t("text_check_image_hight_100kb")}`,
          confirmButtonText: `${t("ok")}`,
        })
      }
    }
    e.target.value = ""
  }

  const onSubmit = () => {
    const postData = async () => {
      setCreateLoading(true)
      try {
        // case remove DMS Files
        let uploadId = checkDmsFileId
        if (documentData && checkDmsFileId.length === 0) {
          const formData = new FormData()
          formData.append("uploadType", "editFiles")
          formData.append("businessPlace", "Betagro")
          formData.append("company", "Betagro")
          formData.append("nameFile", documentData[0]?.name)
          formData.append("createBy", UserId)

          for (let item in documentData) {
            let type: any = documentData[item]
            formData.append(type?.typeUpload, documentData[item])
          }
          const resFilesDoc = await sendFilesDocuments(formData, UserId)

          uploadId =
            resFilesDoc?.status === 200 && resFilesDoc?.data?.contractEmpoyment
              ? resFilesDoc?.data?.contractEmpoyment
              : ""
        }
        const user_id = id as string
        const respEmp = await updateEmployerData(user_id, {
          prefix: userData.prefix,
          first_name_en: userData.first_name_en,
          last_name_en: userData.last_name_en,
          first_name_th: userData.first_name_th,
          last_name_th: userData.last_name_th,
          email: userData.email,
          is_active: active,
          modified_by: decoded?.Username,
          dmsFileId: uploadId,
          telephone: userData.telephone,
          nameFile: newFileName,
        })

        if (respEmp && respEmp?.status === 200) {
          setCreateLoading(false)

          setDocumentData([])
          Swal.fire({
            icon: "success",
            title: `${t("Update status successful!")}`,
            showConfirmButton: false,
            timer: 2000,
          }).then(() => {
            window.location.assign("/admin/masterdata/users?type=employer")
          })
        } else {
          setCreateLoading(false)
          Swal.fire({
            icon: "warning",
            text: `${t("text_choose_image_before_click_upload")}`,
            confirmButtonText: `${t("ok")}`,
          })
        }
      } catch (error) {
        setCreateLoading(false)
        // Handle error
      }
    }

    postData()
  }

  return (
    <>
      <ToastContainer style={{ width: "400px" }} />

      {allSuccessLoading ? (
        <>
          {havePermission ? (
            <>
              <Box sx={{ height: "auto", maxWidth: "100%", mt: 2 }}>
                <Box display="flex" gap={3} sx={{ mb: 3 }}>
                  <Box
                    display="flex"
                    component={ReactRouterLink}
                    onClick={() => window.history.back()}
                    sx={{
                      textDecoration: "none",
                      color: "#0d47a1",
                      alignItems: "center",
                      ":hover": {
                        color: "#1976d2",
                      },
                    }}
                  >
                    <ChevronLeftIcon fontSize="small" />
                    <Typography sx={{ fontWeight: "bold" }}>
                      {t("Back")}
                    </Typography>
                  </Box>
                  <Breadcrumbs aria-label="breadcrumb">
                    <Link
                      underline="hover"
                      sx={{ display: "flex", alignItems: "center" }}
                      color="inherit"
                      component={ReactRouterLink}
                      to="/admin"
                    >
                      <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                      {t("Dashboard")}
                    </Link>
                    <Link
                      underline="hover"
                      sx={{ display: "flex", alignItems: "center" }}
                      color="inherit"
                      component={ReactRouterLink}
                      to={
                        "/admin/masterdata/users?type=" +
                        (editUserType === "Member"
                          ? "member"
                          : editUserType === "HR Recruiter"
                          ? "hr"
                          : editUserType === "employer"
                          ? "employer"
                          : "superadmin")
                      }
                    >
                      <PersonIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                      {t("UserAccount")}
                    </Link>
                    <Typography
                      sx={{ display: "flex", alignItems: "center" }}
                      color="text.primary"
                    >
                      <EditIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                      {t("Edit Data")}
                    </Typography>
                  </Breadcrumbs>
                </Box>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  height: "70px",
                }}
              >
                <Typography
                  variant="h4"
                  sx={{ fontWeight: "bold", textAlign: "left" }}
                >
                  {t("Edit Data")}
                </Typography>
              </Box>
              <Box component="form" noValidate sx={{ mt: 3 }}>
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={2}>
                    <FormControl fullWidth>
                      <InputLabel id="prefix">
                        {t("Prefix")} {isNormalUser && "*"}
                      </InputLabel>
                      <Select
                        labelId="prefix"
                        id="prefix"
                        value={userData.prefix ? userData.prefix : undefined}
                        required={isNormalUser ? true : false}
                        label={t("Prefix")}
                        onChange={handlePrefixChange}
                      >
                        <MenuItem value="Mr">{t("Mr")}</MenuItem>
                        <MenuItem value="Mrs">{t("Mrs")}</MenuItem>
                        <MenuItem value="Miss">{t("Miss")}</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={5}>
                    <TextField
                      required={isNormalUser ? true : false}
                      fullWidth
                      id="firstName"
                      label={t("Thai name")}
                      placeholder={t("Thai name")!}
                      {...register("first_name_th")}
                      error={errors.first_name_th ? true : false}
                      value={userData.first_name_th}
                      onChange={(
                        event: React.ChangeEvent<HTMLInputElement>
                      ) => {
                        setUserData((prevData) => ({
                          ...prevData,
                          first_name_th: event.target.value,
                        }))
                        errors.first_name_th = undefined
                      }}
                    />
                    <Typography
                      variant="inherit"
                      color="error"
                      align="left"
                      pt={1}
                      fontSize={13}
                    >
                      {errors.first_name_th?.message}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={5}>
                    <TextField
                      required={isNormalUser ? true : false}
                      fullWidth
                      id="lastName"
                      label={t("Thai last name")}
                      placeholder={t("Thai last name")!}
                      {...register("last_name_th")}
                      error={errors.last_name_th ? true : false}
                      value={userData.last_name_th}
                      onChange={(
                        event: React.ChangeEvent<HTMLInputElement>
                      ) => {
                        setUserData((prevData) => ({
                          ...prevData,
                          last_name_th: event.target.value,
                        }))
                        errors.last_name_th = undefined
                      }}
                    />
                    <Typography
                      variant="inherit"
                      color="error"
                      align="left"
                      pt={1}
                      fontSize={13}
                    >
                      {errors.last_name_th?.message}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      required
                      id="firstNameEN"
                      label={t("English name")}
                      placeholder={t("English name")!}
                      {...register("first_name_en")}
                      error={errors.first_name_en ? true : false}
                      value={userData.first_name_en}
                      onChange={(
                        event: React.ChangeEvent<HTMLInputElement>
                      ) => {
                        setUserData((prevData) => ({
                          ...prevData,
                          first_name_en: event.target.value,
                        }))
                        errors.first_name_en = undefined
                      }}
                    />
                    <Typography
                      variant="inherit"
                      color="error"
                      align="left"
                      pt={1}
                      fontSize={13}
                    >
                      {errors.first_name_en?.message}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      required
                      id="lastNameEN"
                      label={t("English last name")}
                      placeholder={t("English last name")!}
                      {...register("last_name_en")}
                      error={errors.last_name_en ? true : false}
                      value={userData.last_name_en}
                      onChange={(
                        event: React.ChangeEvent<HTMLInputElement>
                      ) => {
                        setUserData((prevData) => ({
                          ...prevData,
                          last_name_en: event.target.value,
                        }))
                        errors.last_name_en = undefined
                      }}
                    />
                    <Typography
                      variant="inherit"
                      color="error"
                      align="left"
                      pt={1}
                      fontSize={13}
                    >
                      {errors.last_name_en?.message}
                    </Typography>
                  </Grid>

                  {/* <Grid item xs={12} sm={6}>
                        <TextField
                          sx={{
                            backgroundColor: "rgba(0, 0, 0, 0.05)",
                            "& .css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input.Mui-disabled":
                              {
                                WebkitTextFillColor: "rgba(0, 0, 0, 0.7)",
                              },
                          }}
                          disabled
                          fullWidth
                          id="date_of_birth"
                          label={t("Date of birth")}
                          placeholder={t("Date of birth")!}
                          value={
                            dayjs(userData.date_of_birth).format(
                              i18n.language === "th"
                                ? "DD/MM/BBBB"
                                : "MM/DD/YYYY"
                            ) === "Invalid Date"
                              ? ""
                              : dayjs(userData.date_of_birth).format(
                                  i18n.language === "th"
                                    ? "DD/MM/BBBB"
                                    : "MM/DD/YYYY"
                                )
                          }
                        />
                      </Grid> */}
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      error={errors.telephone ? true : false}
                      // required={isNormalUser ? true : false}
                      id="telephone"
                      label={t("Phone Number")}
                      {...register("telephone")}
                      placeholder={t("Phone Number")!}
                      value={userData.telephone}
                      onChange={(
                        event: React.ChangeEvent<HTMLInputElement>
                      ) => {
                        setUserData((prevData) => ({
                          ...prevData,
                          telephone: event.target.value,
                        }))
                      }}
                    />
                    <Typography
                      variant="inherit"
                      color="error"
                      align="left"
                      pt={1}
                      fontSize={13}
                    >
                      {errors.telephone?.message}
                    </Typography>
                  </Grid>

                  <Grid item xs={12} sm={isNormalUser ? 6 : 12}>
                    <TextField
                      sx={{
                        backgroundColor: !isNormalUser
                          ? "rgba(0, 0, 0, 0.05)"
                          : "",
                      }}
                      disabled={!isNormalUser}
                      fullWidth
                      label={isNormalUser ? t("Email") : t("Betagro Email")}
                      placeholder={
                        isNormalUser ? t("Email")! : t("Betagro Email")!
                      }
                      id="email"
                      {...register("email")}
                      error={errors.email ? true : false}
                      value={userData.email === null ? "" : userData.email}
                      onChange={(
                        event: React.ChangeEvent<HTMLInputElement>
                      ) => {
                        setUserData((prevData) => ({
                          ...prevData,
                          email: event.target.value,
                        }))
                        errors.email = undefined
                      }}
                    />
                    <Typography
                      variant="inherit"
                      color="error"
                      align="left"
                      pt={1}
                      fontSize={13}
                    >
                      {errors.email?.message}
                    </Typography>
                  </Grid>
                  <Grid item xs={8}>
                    <FormControlLabel
                      sx={{ paddingTop: 1 }}
                      label={t("Active")}
                      control={
                        <Checkbox
                          checked={userData.is_active}
                          onChange={handleChange}
                          inputProps={{ "aria-label": "Active" }}
                        />
                      }
                    />
                  </Grid>
                </Grid>
                <Grid container spacing={3} sx={{ mt: 2 }}>
                  <Grid item lg={3} xs={12} sm={6} md={6}>
                    <div
                      className={`custom-file-upload ${
                        checkDmsFileId.length > 0 ? "disabled-upload" : ""
                      }`}
                    >
                      <CloudUploadIcon className="upload-icon" />
                      {t("text_signed_file_name")}
                      <input
                        type="file"
                        id="contract"
                        className="file-input"
                        accept="image/png, image/jpeg"
                        onChange={(event) => {
                          handleFileSelection(event, "contract")
                        }}
                        disabled={checkDmsFileId.length > 0}
                      />
                    </div>
                  </Grid>
                  <Grid item lg={6} xs={12} sm={6} md={6}>
                    {userFiles.length > 0 && (
                      <MultipleFileUpload>
                        {documentData.map((file: any, index: number) => (
                          <div key={index}>
                            <MultipleFileUploadStatusItem
                              id="fileContract"
                              className="file-upload-show"
                              file={file}
                              fileName={
                                file.name === undefined
                                  ? "Signed Image"
                                  : `${file.name}`
                              }
                              key={
                                file.name === undefined
                                  ? "Signed Image"
                                  : `${file.name}`
                              }
                              onClearClick={() => removeFiles([file.name])}
                              onReadSuccess={handleReadSuccess}
                              onReadFail={handleReadFail}
                              fileIcon={<UploadFileIcon color="secondary" />}
                            />
                          </div>
                        ))}
                      </MultipleFileUpload>
                    )}
                    {documentData.length > 0 && (
                      <MultipleFileUpload>
                        {documentData.map((file: any, index: number) => (
                          <div key={`doc-${index}`}>
                            <MultipleFileUploadStatusItem
                              className="file-upload-item"
                              file={file}
                              fileName={
                                file?.name === undefined
                                  ? "Signed Image"
                                  : `${file?.name}`
                              }
                              key={
                                file?.name === undefined
                                  ? "Signed Image"
                                  : `${file?.name}`
                              }
                              onClearClick={() => {
                                setDocumentData([])
                                setCheckDmsFileId("")
                                setValue("fileContract", [])
                              }}
                              onReadSuccess={handleReadSuccess}
                              onReadFail={handleReadFail}
                              progressValue={100}
                              fileIcon={<UploadFileIcon color="secondary" />}
                            />
                          </div>
                        ))}
                      </MultipleFileUpload>
                    )}
                  </Grid>
                </Grid>
                {/* move signed image */}
                <Grid container spacing={3}>
                  <Grid item lg={3} md={3} sm={8} xs={8}>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        height: "70px",
                      }}
                    >
                      {t("text_signed_file_name")} :
                      <a onClick={() => debugBase64(dmsImageData)}>
                        Signed Image
                      </a>
                    </Box>
                  </Grid>
                  {/* <Grid item xs={6}>
                    ss
                  </Grid>
                  <Grid item xs={6}>
                    <Box>
                      <a onClick={() => debugBase64(dmsImageData)}>
                        Signed Image
                      </a>
                    </Box>
                  </Grid> */}
                </Grid>
                <Grid container spacing={3}>
                  <Grid item xs={6}>
                    <Button
                      fullWidth
                      type="submit"
                      variant="contained"
                      disabled={editLoading}
                      sx={{ mt: 5, mb: 2 }}
                      onClick={handleSubmit(onSubmit)}
                    >
                      {t("Edit")}
                      {editLoading && (
                        <CircularProgress
                          size={24}
                          sx={{
                            color: green[500],
                            position: "absolute",
                            zIndex: 999,
                          }}
                        />
                      )}
                    </Button>
                  </Grid>
                  <Grid item xs={6}>
                    <Button
                      fullWidth
                      variant="outlined"
                      sx={{ mt: 5, mb: 2 }}
                      component={ReactRouterLink}
                      to={`/admin/masterdata/users?type=${
                        editUserType === "Member"
                          ? "member"
                          : editUserType === "HR Recruiter"
                          ? "hr"
                          : editUserType === "employer"
                          ? "employer"
                          : "superadmin"
                      }`}
                    >
                      {t("Cancel")}
                    </Button>
                  </Grid>
                </Grid>
              </Box>
            </>
          ) : null}{" "}
        </>
      ) : (
        <>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "70vh",
            }}
          >
            <CircularProgress />
          </Box>
        </>
      )}
    </>
  )
}

export default EditEmp
